<div class="card">

    <div class="col-12" *ngIf="!permissaoListar">
        <div style="text-align: center">
            <h4>Você não possui permissão de acesso essa página!</h4>
        </div>
    </div>
    <div class="col-12" *ngIf="permissaoListar">
        <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
        <div class="flex justify-content-between align-items-end gap-3 mb-5">
            <div class="flex flex-column gap-1">
                <div class="flex align-items-center gap-2">
                    <button
                        pButton
                        pRipple
                        icon="pi pi-angle-left"
                        pTooltip="Anterior"
                        type="button"
                        class="p-button-outlined p-button-primary"
                        (click)="voltarDiaCalendario()"
                    ></button>

                    <p-calendar
                        dateFormat="D, dd/mm/yy"
                        [required]="true"
                        name="dataSelecionadaCalendario"
                        [(ngModel)]="dataSelecionadaCalendario"
                        (ngModelChange)="selecionarDataPeloCalendario($event)"
                    ></p-calendar>

                    <button
                        pButton
                        pRipple
                        icon="pi pi-angle-right"
                        pTooltip="Próximo"
                        type="button"
                        class="p-button-outlined p-button-primary"
                        (click)="avancarDiaCalendario()"
                    ></button>

                    <span class="mx-1"></span>

                    <button
                        pButton
                        pRipple
                        label="Hoje"
                        pTooltip="Data atual"
                        type="button"
                        class="p-button-primary p-button-outlined"
                        (click)="diaAtualCalendario()"
                    ></button>
                    <p-multiSelect
                        [options]="listaFiltroGrupos"
                        [(ngModel)]="listaFiltroGruposSelecionados"
                        [filter]="false"
                        defaultLabel="Grupos"
                        optionLabel="descricao"
                        optionValue="id"
                        (ngModelChange)="carregarConfiguracoesDaAgenda()"
                    ></p-multiSelect>
                </div>
            </div>

            <div class="flex align-items-end gap-1">
                <button
                    pButton
                    pRipple
                    label="Clientes"
                    pTooltip="Ver detalhes"
                    tooltipPosition="bottom"
                    type="button"
                    icon="pi pi-users"
                    class="p-button-primary p-button-outlined shadow-none"
                    (click)="abrirDialogDetalheAgendaCliente()"
                ></button>
                <button
                    pButton
                    pRipple
                    label="Bloqueio"
                    pTooltip="Adicionar Bloqueio"
                    tooltipPosition="bottom"
                    type="button"
                    icon="pi pi-lock"
                    class="p-button-primary p-button-outlined shadow-none"
                    (click)="abrirDialogInserirBloqueio()"
                ></button>
            </div>
        </div>
        <div class="flex justify-content-end align-items-center gap-1">
            
            <p-dropdown
                [options]="totalItensPagina"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="tamanhoPagina"
                (onChange)="alterarTamanhoPagina()"
                appendTo="body"
            ></p-dropdown>
            <button
                pButton
                pRipple
                class="p-button-primary p-button-outlined shadow-none"
                icon="pi pi-angle-left"
                type="button"
                pTooltip="Voltar"
                (click)="paginaAnterior()"
                [disabled]="estaNaPrimeiraPagina()"
            ></button>


            
            <span class="text-base mx-2">
                {{paginaAtualExibicao}} página(s) de {{totalPaginas}}
            </span>

            <button
                pButton
                pRipple
                class="p-button-primary p-button-outlined shadow-none"
                icon="pi pi-angle-right"
                type="button"
                pTooltip="Avançar"
                (click)="proximaPagina()"
                [disabled]="estaNaUltimaPagina()"
            ></button>
        </div>
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
</div>

<!--INSERIR AGENDAMENTO-->
<p-dialog
    #inserirEventoAgenda
    [(visible)]="exibirInserirEventoAgenda"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '40rem' }"
    [modal]="true"
    [closable]="true"
    [resizable]="false"
    [draggable]="false"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 w-full">
            <span class="text-xl font-semibold text-900">
                {{ profissionalSelecionado?.nomeProfissional }}
            </span>
            <div
                class="flex align-items-center gap-1 px-2 py-1 border-1 surface-border border-round"
            >
                <i class="pi pi-calendar text-700"></i>
                <span class="text-900 text-base">
                    {{ dataSelecionadaCalendario | date : "dd/MM/yyyy" }}
                </span>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <p-messages
            [(value)]="messagesDialog"
            [enableService]="false"
            [closable]="true"
        ></p-messages>
        <div class="formgrid grid p-fluid mt-2">
            <div class="col-12 md:col-6">
                <div class="field-radiobutton">
                    <p-radioButton
                        name="tipoEvento"
                        value="AGENDAMENTO"
                        [(ngModel)]="tipoEventoAgenda"
                        id="tipoEvento1"
                    ></p-radioButton>
                    <label for="tipoEvento1">Agendamento</label>
                </div>
            </div>
            <div class="col-12 md:col-6">
                <div class="field-radiobutton">
                    <p-radioButton
                        name="tipoEvento"
                        value="BLOQUEIO"
                        [(ngModel)]="tipoEventoAgenda"
                        id="tipoEvento"
                    ></p-radioButton>
                    <label for="tipoEvento">Bloqueio</label>
                </div>
            </div>

            <ng-container *ngIf="tipoEventoAgenda === 'AGENDAMENTO'; else bloqueio">
                <div class="col-12 field">
                    <label for="cliente" class="text-900 font-semibold">Cliente</label>
                    <div class="p-inputgroup">
                        <label id="cliente" class="form-control-agrupado">
                            {{ clienteSelecionado?.nome }}
                        </label>
                        <button
                            pButton
                            pRipple
                            pTooltip="Próximo"
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-success"
                            (click)="abrirSelecaoCliente()"
                        ></button>
                    </div>
                </div>
                <div class="col-12 field">
                    <label for="servico" class="text-900 font-semibold">Serviço</label>
                    <div class="p-inputgroup">
                        <label id="servico" class="form-control-agrupado">Selecionar Serviço</label>
                        <button
                            pButton
                            pRipple
                            pTooltip="Selecionar Serviço"
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-success"
                            (click)="abrirDialogSelecaoServico()"
                        ></button>
                    </div>
                </div>

                <div
                    class="col-12 field"
                    *ngIf="servicosNovoAgendamento.length > 0 || novoAgendamento.itemExclusivoId"
                >
                    <div class="flex flex-column border-1 surface-border border-round p-2 gap-2">
                        <div
                            *ngIf="novoAgendamento.itemExclusivoId"
                            class="flex justify-content-between align-items-center surface-50 border-round p-2"
                        >
                            <span>
                                {{ descricaoItemExclusivoSelecionado }}
                                <span class="status-badge-agenda-alt">EXCLUSIVO</span>
                            </span>
                            <button
                                pButton
                                pRipple
                                icon="pi pi-trash"
                                class="p-button-danger p-button-sm"
                                pTooltip="Remover item exclusivo"
                                (click)="removerItemExclusivo()"
                            ></button>
                        </div>

                        <p-divider
                            *ngIf="
                                servicosNovoAgendamento.length > 0 &&
                                novoAgendamento.itemExclusivoId
                            "
                        ></p-divider>

                        <div
                            *ngFor="let item of servicosNovoAgendamento; let i = index"
                            class="flex align-items-center surface-50 border-round p-2"
                        >
                            <div class="flex-1">
                                <span class="text-900">
                                    {{ item.descricao }}
                                </span>
                            </div>

                            <div class="w-6rem text-right text-600 mr-2">
                                <span>{{ item.tempoMedio }}</span>
                            </div>

                            <div class="w-3rem h-3rem flex justify-content-end">
                                <button
                                    pButton
                                    pRipple
                                    icon="pi pi-trash"
                                    class="p-button-danger p-button-sm"
                                    pTooltip="Remover serviço"
                                    (click)="removerServicoAgendamento(i)"
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-4 field">
                    <label for="inicio" class="text-900 font-semibold">Início</label>
                    <label id="inicio" class="form-control">
                        {{ novoAgendamento.horaInicio?.substring(0, 5) }}
                    </label>
                </div>

                <div class="col-12 md:col-4 field">
                    <label for="fim" class="text-900 font-semibold">Fim</label>
                    <label id="fim" class="form-control">
                        {{ novoAgendamento.horaFim?.substring(0, 5) }}
                    </label>
                </div>
                <div class="col-4 mt-4">
                    <div class="grid formgrid">
                        <div class="col-12">
                            <div class="field-checkbox">
                                <p-checkbox
                                    name="check1"
                                    [binary]="true"
                                    [(ngModel)]="novoAgendamento.preferencial"
                                    inputId="preferencial"
                                ></p-checkbox>
                                <label for="preferencial">Preferencial</label>
                            </div>
                            <div class="field-checkbox">
                                <p-checkbox
                                    name="check2"
                                    [binary]="true"
                                    [(ngModel)]="novoAgendamento.recorrente"
                                    inputId="recorrente"
                                ></p-checkbox>
                                <label for="recorrente">Recorrente</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-9 field" *ngIf="novoAgendamento.recorrente">
                    <p-calendar
                        [(ngModel)]="datasRecorrenciaAgendamento"
                        [minDate]="minDateAgendamento"
                        [maxDate]="maxDateAgendamento"
                        selectionMode="multiple"
                        [inline]="true"
                        #calendarioRecorrencia
                    ></p-calendar>
                </div>
                <div
                    class="col-3 field"
                    *ngIf="novoAgendamento.recorrente && datasRecorrenciaAgendamento?.length"
                >
                    <div class="flex flex-wrap justify-content-center gap-1">
                        <p-chip
                            *ngFor="let data of datasRecorrenciaAgendamento"
                            [removable]="true"
                            (onRemove)="removerDataRecorrencia(data)"
                        >
                            {{ data | date : "dd/MM/yyyy" }}
                        </p-chip>
                    </div>
                </div>

                <div class="col-12 field" *ngIf="novoAgendamento">
                    <label for="description" class="text-900 font-semibold">Informações</label>
                    <textarea
                        id="description"
                        type="text"
                        pInputTextarea
                        [rows]="2"
                        [(ngModel)]="novoAgendamento.descricao"
                        style="resize: none"
                    ></textarea>
                </div>
            </ng-container>

            <ng-template #bloqueio>
                <div class="col-12 md:col-4 field">
                    <label for="inicio" class="text-900 font-semibold">Início</label>
                    <label id="inicio" class="form-control">
                        {{
                            novoBloqueioAgenda.horaInicio
                                ? novoBloqueioAgenda.horaInicio.substring(0, 5)
                                : ""
                        }}
                    </label>
                </div>
                <div class="col-12 md:col-4 field">
                    <label for="fim" class="text-900 font-semibold">Fim</label>
                    <p-inputMask
                        mask="99:99"
                        placeholder="00:00"
                        type="text"
                        name="fim"
                        [(ngModel)]="novoBloqueioAgenda.horaFim"
                    ></p-inputMask>
                </div>
                <div class="col-12 md:col-4 field">
                    <div class="field-checkbox mt-6">
                        <p-checkbox
                            name="checkRecorrente"
                            [binary]="true"
                            [(ngModel)]="novoBloqueioAgenda.recorrente"
                            inputId="bloqRecorrente"
                        ></p-checkbox>
                        <label for="bloqRecorrente">Recorrente</label>
                    </div>
                </div>
                <div class="col-9 field" *ngIf="novoBloqueioAgenda.recorrente">
                    <p-calendar
                        [(ngModel)]="datasRecorrenciaBloqueio"
                        [minDate]="minDateBloqueio"
                        [maxDate]="maxDateBloqueio"
                        selectionMode="multiple"
                        [inline]="true"
                    ></p-calendar>
                </div>
                <div
                    class="col-3 field"
                    *ngIf="novoBloqueioAgenda.recorrente && datasRecorrenciaBloqueio?.length"
                >
                    <div class="flex flex-wrap justify-content-center gap-1">
                        <p-chip
                            *ngFor="let data of datasRecorrenciaBloqueio"
                            [removable]="true"
                            (onRemove)="removerDataRecorrenciaBloqueio(data)"
                        >
                            {{ data | date : "dd/MM/yyyy" }}
                        </p-chip>
                    </div>
                </div>
                <div class="col-12 field">
                    <label for="description" class="text-900 font-semibold">Informações</label>
                    <textarea
                        id="description"
                        type="text"
                        pInputTextarea
                        [rows]="2"
                        [(ngModel)]="novoBloqueioAgenda.descricao"
                        style="resize: none"
                    ></textarea>
                </div>
            </ng-template>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-between">
            <button
                pButton
                label="Salvar"
                class="p-button-outlined p-button-success w-3"
                icon="pi pi-pencil"
                (click)="salvarEvento()"
            ></button>
            <button
                pButton
                class="p-button-outlined p-button-danger w-3"
                label="Cancelar"
                icon="pi pi-times"
                (click)="exibirInserirEventoAgenda = false"
            ></button>
        </div>
    </ng-template>
</p-dialog>

<!--EXIBIR AGENDAMENTO-->
<p-dialog
    [(visible)]="exibirDetalheAgendamento"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '36rem' }"
    [modal]="true"
    class="p-fluid"
    [resizable]="false"
    [draggable]="false"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 w-full">
            <span class="text-xl font-semibold text-900">
                <i class="pi pi-users"></i>
                {{ agendamentoSelecionado?.nomeProfissional }}
            </span>
            <div
                class="flex align-items-center gap-1 px-2 py-1 border-1 surface-border border-round"
            >
                <i class="pi pi-calendar text-700"></i>
                <span class="text-900 text-base">
                    {{ agendamentoSelecionado?.dataAgendamento | date : "dd/MM/yyyy" }}
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages
            [(value)]="messagesDialog"
            [enableService]="false"
            [closable]="true"
        ></p-messages>

        <div *ngIf="loadingDetalheAgendamento" class="flex justify-content-center py-4">
            <p-progressSpinner></p-progressSpinner>
        </div>

        <div *ngIf="agendamentoSelecionado && !loadingDetalheAgendamento" class="grid mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="flex flex-column align-items-center gap-3">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-user text-700"></i>
                            <span class="text-900 font-semibold">
                                {{ agendamentoSelecionado.nomeCliente }}
                            </span>
                        </div>

                        <div class="flex align-items-center gap-3">
                            <span
                                class="status-badge-agenda"
                                [ngStyle]="agendamentoSelecionado.status | agendaStatusStyle"
                            >
                                {{ agendamentoSelecionado.status }}
                            </span>

                            <span class="badge-clock">
                                <i class="pi pi-clock"></i>
                                {{ agendamentoSelecionado.horaInicio.substring(0, 5) }}
                                -
                                {{ agendamentoSelecionado.horaFim.substring(0, 5) }}
                            </span>

                            <span class="status-badge-agenda-alt">
                                {{ agendamentoSelecionado.tipo }}
                            </span>
                        </div>

                        <button
                            *ngIf="agendamentoSelecionado.comandaId"
                            pButton
                            pRipple
                            icon="pi pi-eye"
                            label="Ver comanda"
                            class="p-button-text p-button-primary w-5"
                            (click)="abrirComanda()"
                        ></button>
                    </div>
                    <div
                        class="flex justify-content-end gap-2 mt-5"
                        *ngIf="
                            agendamentoSelecionado.status === 'AGENDADO' ||
                            agendamentoSelecionado.status === 'CONFIRMADO'
                        "
                    >
                        <label for="preferencialSw">Preferencial?</label>
                        <p-inputSwitch
                            name="preferencialSw"
                            [(ngModel)]="agendamentoSelecionado.preferencial"
                            (ngModelChange)="alterarPreferencia($event)"
                        ></p-inputSwitch>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card">
                    <div class="flex justify-content-start mb-3">
                        <button
                            pButton
                            pRipple
                            icon="pi pi-plus"
                            class="p-button-outlined"
                            pTooltip="Incluir Serviço"
                            (click)="abrirDialogSelecaoServico()"
                            [disabled]="agendamentoSelecionado.status !== 'AGENDADO'"
                        ></button>
                    </div>
                    <div *ngIf="agendamentoSelecionado.descricaoItemExclusivo" class="mb-3">
                        <div
                            class="flex align-items-center justify-content-start surface-100 border-round p-3"
                        >
                            <i class="pi pi-map-marker text-primary mr-2 text-xl"></i>
                            <span class="text-900 font-medium text-lg mr-2">
                                {{ agendamentoSelecionado.descricaoItemExclusivo }}
                            </span>
                            <span class="status-badge-agenda-alt text-xs">EXCLUSIVO</span>
                        </div>
                    </div>

                    <div
                        [ngClass]="{
                            'ml-4 border-left-1 border-300 pl-3':
                                agendamentoSelecionado.descricaoItemExclusivo
                        }"
                    >
                        <div class="flex flex-column gap-2 mb-3">
                            <div
                                *ngFor="let item of agendamentoSelecionado.items"
                                class="flex align-items-center justify-content-between surface-50 border-round p-2"
                            >
                                <span class="text-900">
                                    {{ item.descricao }}
                                </span>

                                <div class="flex align-items-center gap-3">
                                    <span class="text-600">
                                        {{ item.duracao }}
                                    </span>

                                    <button
                                        pButton
                                        pRipple
                                        icon="pi pi-trash"
                                        class="p-button-danger p-button-sm"
                                        pTooltip="Remover serviço"
                                        (click)="excluirServicoAgendamento(item.id)"
                                        [disabled]="agendamentoSelecionado.status !== 'AGENDADO'"
                                    ></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p-divider class="my-4"></p-divider>

                    <div class="flex align-items-center justify-content-between mb-2">
                        <label class="text-900 font-medium">Observação</label>
                        <button
                            *ngIf="!modoEdicaoDescricao"
                            pButton
                            pRipple
                            icon="pi pi-pencil"
                            class="p-button-outlined p-button-sm"
                            pTooltip="Editar observação"
                            (click)="habilitarEdicaoDescricao()"
                            [disabled]="
                                agendamentoSelecionado.status !== 'AGENDADO' &&
                                agendamentoSelecionado.status !== 'CONFIRMADO'
                            "
                        ></button>
                    </div>

                    <textarea
                        pInputTextarea
                        [rows]="2"
                        [(ngModel)]="agendamentoSelecionado.descricao"
                        [readOnly]="!modoEdicaoDescricao"
                        style="resize: none"
                    ></textarea>

                    <div
                        *ngIf="modoEdicaoDescricao"
                        class="flex justify-content-between gap-2 mt-2"
                    >
                        <button
                            pButton
                            pRipple
                            label="Salvar"
                            icon="pi pi-check"
                            class="p-button-outlined p-button-success w-4"
                            (click)="salvarDescricao()"
                        ></button>
                        <button
                            pButton
                            pRipple
                            label="Cancelar"
                            class="p-button-outlined p-button-danger w-4"
                            (click)="cancelarEdicaoDescricao()"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex flex-wrap justify-content-end gap-1" *ngIf="agendamentoSelecionado">
            <button
                type="button"
                pButton
                class="p-button-success w-3rem"
                icon="pi pi-whatsapp"
                pTooltip="WhatsApp"
                [disabled]="!agendamentoSelecionado.telefone"
            ></button>
            <button
                *ngIf="agendamentoSelecionado.status === 'ATENDIDO'"
                pButton
                pRipple
                pTooltip="Remarcar Agendamento"
                icon="pi pi-check-square"
                class="p-button-success w-3rem"
            ></button>
            <button
                *ngIf="agendamentoSelecionado.status === 'AGENDADO'"
                pButton
                pRipple
                pTooltip="Confirmar Agendamento"
                icon="pi pi-check"
                class="p-button-success w-3rem"
                (click)="confirmarAgendamento()"
            ></button>
            <button
                *ngIf="
                    agendamentoSelecionado.status === 'CONFIRMADO' &&
                    !agendamentoSelecionado.comandaId
                "
                pButton
                pRipple
                pTooltip="Criar Comanda"
                icon="pi pi-table"
                class="p-button-primary w-3rem"
                (click)="criarComandaAgendamento()"
            ></button>
            <button
                *ngIf="
                    agendamentoSelecionado.status === 'AGENDADO' ||
                    agendamentoSelecionado.status === 'CONFIRMADO'
                "
                pButton
                pRipple
                pTooltip="Cancelar"
                icon="pi pi-times"
                class="p-button-warning w-3rem"
                (click)="cancelarAgendamento()"
            ></button>
        </div>
    </ng-template>
</p-dialog>

<!-- <app-agendamento-detalhe-dialog
    [(visible)]="exibirDialogAgendamento"
    [agendamentoId]="idAgendamentoClicado"
    (confirmar)="acaoConfirmarAgendamento($event)"
    (excluir)="acaoExcluirAgendamento($event)">

</app-agendamento-detalhe-dialog> -->

<app-bloqueio-inserir
    [(visible)]="exibirInserirBloqueio"
    [dataBloqueio]="dataBloqueio"
    [selectProfissinaisBloqueio]="profissionaisHabilitadosBloqueio"
    (salvar)="verificarSalvarBloqueio($event)"
></app-bloqueio-inserir>

<app-bloqueio-detalhe
    [(visible)]="exibirDetalheBloqueio"
    [bloqueioId]="bloqueioIdSelecionado"
    (excluir)="verificarExclusaoBloqueio($event)"
></app-bloqueio-detalhe>

<app-select-cliente-dialog
    [(visible)]="exibirSelecaoCliente"
    (selecionar)="selecionarCliente($event)"
></app-select-cliente-dialog>

<app-select-servico-agendamento-dialog
    [visible]="exibirSelecaoServico"
    (visibleChange)="exibirSelecaoServico = $event"
    [profissionalId]="profissionalSelecionado?.id"
    (selecionar)="selecionarServico($event)"
></app-select-servico-agendamento-dialog>

<app-profissional-agenda-detalhe
    [(visible)]="exibirDetalheAgendaProfissional"
    [profissional]="profissionalSelecionado"
    [dataSelecionada]="dataSelecionadaCalendario"
    (selecionar)="abrirDetalheAgendamentoPorProfissional($event)"
></app-profissional-agenda-detalhe>

<app-cliente-agenda-detalhe
    [(visible)]="exibirDetalheAgendaCliente"
    (agendamentoReativado)="carregarConfiguracoesDaAgenda()"
    (agendamentoReagendado)="verificarRecarregarReagendamento($event)"
></app-cliente-agenda-detalhe>

<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>

<p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
  <ng-template pTemplate>
     <div>
       detalhes do evento
    </div>
   </ng-template>
 </p-overlayPanel>
